module.exports = __webpack_public_path__ + "static/img/Chevron-fluid-mark-Anim444.1e7da6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/Chevron-fluid-mark-Anim444.svg
// module id = p1+D
// module chunks = 1